module.exports = __webpack_public_path__ + "img/products-4.a04271a.webp";